import React, { Component } from 'react';

class IconList extends Component
{
    render = () => {
        return (
            <svg className="icon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	  viewBox="0 0 283.465 283.465" enableBackground="new 0 0 283.465 283.465"
	 xmlSpace="preserve">
                <rect width="283.465" height="283.465" />
                <g>
                    <defs>
                        <rect id="SVGID_1_" width="283.465" height="283.465" />
                    </defs>
                    <clipPath id="SVGID_2_">
                        <use xlinkHref="#SVGID_1_"  overflow="visible"/>
                    </clipPath>
                    <path clipPath="url(#SVGID_2_)" d="M107.879,80.444c0,0-5.669,0-5.669,5.669v21.417c0,0,0,5.669,5.669,5.669
                        h112.805c0,0,5.669,0,5.669-5.669V86.113c0,0,0-5.669-5.669-5.669H107.879z"/>
                    <path clipPath="url(#SVGID_2_)" d="M107.879,125.452c0,0-5.669,0-5.669,5.669v21.417c0,0,0,5.669,5.669,5.669
                        h112.805c0,0,5.669,0,5.669-5.669v-21.417c0,0,0-5.669-5.669-5.669H107.879z"/>
                    <path clipPath="url(#SVGID_2_)" d="M107.879,170.266c0,0-5.669,0-5.669,5.669v21.417c0,0,0,5.669,5.669,5.669
                        h112.805c0,0,5.669,0,5.669-5.669v-21.417c0,0,0-5.669-5.669-5.669H107.879z"/>
                    <path clipPath="url(#SVGID_2_)" d="M62.781,80.444c0,0-5.669,0-5.669,5.669v21.417c0,0,0,5.669,5.669,5.669h20.126
                        c0,0,5.669,0,5.669-5.669V86.113c0,0,0-5.669-5.669-5.669H62.781z"/>
                    <path clipPath="url(#SVGID_2_)" d="M62.781,125.452c0,0-5.669,0-5.669,5.669v21.417c0,0,0,5.669,5.669,5.669
                        h20.126c0,0,5.669,0,5.669-5.669v-21.417c0,0,0-5.669-5.669-5.669H62.781z"/>
                    <path clipPath="url(#SVGID_2_)" d="M62.781,170.266c0,0-5.669,0-5.669,5.669v21.417c0,0,0,5.669,5.669,5.669
                        h20.126c0,0,5.669,0,5.669-5.669v-21.417c0,0,0-5.669-5.669-5.669H62.781z"/>
                </g>
            </svg>
        );
    }
}

export default IconList;


// WEBPACK FOOTER //
// ./src/components/App/IconList.js